import React from 'react';
import DocumentoNoDisponible from './DocumentoNoDisponible';

const CompendioCap8 = () => (
  <DocumentoNoDisponible titulo="Compendio Estadístico 2017 - 2021 · Capítulo 8" />
);

export default CompendioCap8;
